import { DEFAULT_THEME_ID, THEME_IDS } from '../../../styles/themes';

const ALLOWED_NON_DEFAULT = new Set(
  THEME_IDS.filter((id) => id !== DEFAULT_THEME_ID),
);

/** @param {string} themeId */
export function normalizeThemeId(themeId) {
  if (typeof themeId === 'string' && ALLOWED_NON_DEFAULT.has(themeId)) {
    return themeId;
  }
  return DEFAULT_THEME_ID;
}

/**
 * Theme from Django setting display.ui_theme
 * @param {string | undefined | null} raw
 */
export function parseThemeSetting(raw) {
  const s = typeof raw === 'string' ? raw.trim() : '';
  if (ALLOWED_NON_DEFAULT.has(s)) {
    return s;
  }
  return DEFAULT_THEME_ID;
}

/**
 * @param {string} themeId
 */
export function applyTheme(themeId) {
  const id = normalizeThemeId(themeId);
  const root = document.documentElement;

  if (id === DEFAULT_THEME_ID) {
    root.removeAttribute('data-ph-theme');
  } else {
    root.setAttribute('data-ph-theme', id);
  }
}

/** @returns {string} normalized theme id */
export function appliedThemeSnapshot() {
  const raw = document.documentElement.getAttribute('data-ph-theme');
  return parseThemeSetting(raw);
}
